import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Backdrop, CircularProgress } from '@material-ui/core'

interface ConfirmDialogProps {
  modalOpen: boolean
  handleNo: () => void
  handleYes: () => void
  content: string
  title: string
  isLoading?: boolean
}

const ConfirmDialog = ({
  handleNo,
  handleYes,
  modalOpen,
  content,
  title,
  isLoading,
}: ConfirmDialogProps) => (
  <Dialog
    open={modalOpen}
    onClose={handleNo}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title" data-testid="dialog-title">
      {title}
    </DialogTitle>
    <DialogContent>
      <DialogContentText
        id="alert-dialog-description"
        data-testid="dialog-message"
      >
        {content}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleNo} color="primary" data-testid="dialog-no">
        No
      </Button>
      <Button
        onClick={handleYes}
        color="primary"
        autoFocus
        data-testid="dialog-yes"
      >
        Yes
      </Button>
    </DialogActions>
  </Dialog>
)

export default ConfirmDialog
